import { SdfButton, SdfShimmer, SdfSwitch, SdfTooltip } from '@synerg/react-components';
import { uniqueId } from 'lodash';
import React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';


export const CredentialsBox = ({ clientType, clientId = '', clientSecret = '', showSecret = false, loadingClientId, loadingSecret, toggleShowSecret }) => {
  return (
    <div>
      <div className="flex flex-wrap justify-between items-center mt-2 gap-x-4">
        <div className="text-heading-02 font-bold">
          ClientID
        </div>
        {loadingClientId ? <SdfShimmer className='w-sm' />
          :
          <div className="flex items-center">
            <div className="text-body-02 mr-6">
              {clientId}
            </div>
            {clientId ?
              <CopyToClipboard text={clientId}>
                <SdfTooltip positionContext="ELEMENT" tooltipId={uniqueId} trigger="click" state="info">
                  <SdfButton emphasis="primary" slot="tooltip-target"> Copy </SdfButton>
                  Copied
                </SdfTooltip>
              </CopyToClipboard>
              :
              <SdfButton disabled={true} emphasis="primary" slot="tooltip-target"> Copy </SdfButton>
            }
          </div>
        }
      </div>

      <div className="flex flex-wrap justify-between items-center mt-6 gap-x-4">
        <div className="text-heading-02 font-bold">
          Client secret
        </div>
        <div className="flex items-center">
          <div className="flex items-center mr-10">
            <SdfSwitch
              checked={showSecret}
              {...((!clientId || clientId === 'Not available') && { disabled: true })}
              onSdfChange={(event) => {
                toggleShowSecret(event.detail, clientType)
              }}
            />
            <span slot="label" className="text-md text-action-primary font-medium mr-1">Reveal </span>
          </div>
          {loadingSecret ? <SdfShimmer className='w-sm' /> :
            <>
              {showSecret ? <div className="text-body-02 mr-6">
                {clientSecret}
              </div> : <div className="text-body-02 mr-6 pt-1">*****************************************</div>}
              {clientSecret ?
                <CopyToClipboard text={clientSecret}>
                  <SdfTooltip positionContext="ELEMENT" tooltipId={uniqueId} trigger="click" state="info">
                    <SdfButton emphasis="primary" slot="tooltip-target"> Copy </SdfButton>
                    Copied
                  </SdfTooltip>
                </CopyToClipboard>
                :
                <SdfButton disabled={true} emphasis="primary" slot="tooltip-target"> Copy </SdfButton>
              }
            </>}
        </div>
      </div>
    </div>
  );
};
